import ClientStorage from '@naturehouse/nh-essentials/lib/storage/Storage';
import LocalStorageStrategy from '@naturehouse/nh-essentials/lib/storage/strategies/LocalStorageStrategy';
import type AbstractStorageStrategy from '@naturehouse/nh-essentials/lib/storage/strategies/AbstractStorageStrategy';

export type PersistedAccountVerificationState = {
    cooldownEndsAt: number | null;
    successCount: number;
    lastSuccessAt: number | null;
};

export default class AccountVerificationStorage {
    public static readonly DATABASE_NAME: string = 'AccountVerification';

    static #instance: AccountVerificationStorage | null = null;

    readonly #storageKey: string = 'account-verification';

    public static getInstance(): AccountVerificationStorage {
        if (this.#instance === null) {
            this.#instance = new AccountVerificationStorage();
        }

        return this.#instance;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    public async getState(): Promise<PersistedAccountVerificationState | null> {
        const storage = await this.#getStorage();

        return storage.getItem(this.#storageKey);
    }

    public async saveState(state: PersistedAccountVerificationState): Promise<void> {
        const storage = await this.#getStorage();
        const existingState = await storage.getItem(this.#storageKey);

        if (existingState === null) {
            await storage.setItem(this.#storageKey, state);

            return;
        }

        await storage.updateItem(this.#storageKey, state);
    }

    public async clear(): Promise<void> {
        const storage = await this.#getStorage();

        await storage.removeItem(this.#storageKey);
    }

    async #getStorage(): Promise<AbstractStorageStrategy<PersistedAccountVerificationState>> {
        return ClientStorage.retrieveStorage<PersistedAccountVerificationState>(
            AccountVerificationStorage.DATABASE_NAME,
            LocalStorageStrategy
        );
    }
}
